import React from 'react';
import { Fab, withStyles } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons//DeleteOutline';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from './styles';

const PF2MDiscardChangesButton = ({
  onClick,
  disabled,
  classes,
  size,
  ...props
}) => {
  const { t: translate } = useTranslation();

  return (
    <Fab
      variant="extended"
      color="primary"
      size={size}
      onClick={onClick}
      disabled={disabled}
      className={classes.button}
      {...props}
    >
      <DeleteOutlineIcon className={classes.icon} />
      {translate('common:DiscardChanges').toUpperCase()}
    </Fab>
  );
};

PF2MDiscardChangesButton.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  onClick: PropTypes.any,
  size: PropTypes.string,
};

PF2MDiscardChangesButton.defaultProps = {
  classes: {},
  disabled: false,
  onClick: {},
  size: 'large',
};

export default withStyles(styles)(PF2MDiscardChangesButton);
